import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../util';

function EmptyState({ title, text, children, className = "", showBotxi = true }) {
    return (
        <div className={cn("w-full bg-white py-16 border border-gray-200 px-4 text-center rounded-md", className)}>
            {showBotxi ? (
                <div>
                    <img 
                    alt='Botxi - crea una incidencia'
                    src='https://cdn.fixat.mx/intranet/botxi.png'
                    className='w-[105px] h-[132px] mx-auto'
                    />
                </div>
            ) : null}
            <div className='text-gray-900 font-medium text-2xl text-center mt-4'>
                { title }
            </div>
            <div className='text-gray-600 mt-2'>
                { text } 
            </div>
            { children }
        </div>
    )
}

EmptyState.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    children: PropTypes.any,
    className: PropTypes.string,
    showBotxi: PropTypes.bool
}

export default EmptyState